$bog_builderui_studio $bog_builderui_div
	plugins /
		<= Favicon $bog_favicon
			Icon <= favicon_icon $mol_icon_palette
		<= Skin $bog_builderui_skin
			lights <= lights? \dark
			base <= base? \slate
			accent <= theme? \sky
			chart <= chart? \blue
			radius <= radius? \medium
			font_body <= font_body? \inter
			font_head <= font_head? \inter
	sub /
		<= Sidebar $mol_view sub /
			<= Title $mol_view sub / \$mol BuilderUI Studio
			<= Group_style $mol_view sub /
				<= Style_pick $bog_builderui_studio_pick
					label \Style
					value? <=> style_id? \Default
					dictionary <= style_dict *
			<= Group_colors $mol_view sub /
				<= Base_pick $bog_builderui_studio_pick
					label \Base Color
					value? <=> base? \slate
					dot_color \var(--bog_builderui_shade)
					dictionary *
						slate \Slate
						stone \Stone
						zinc \Zinc
						gray \Gray
				<= Theme_pick $bog_builderui_studio_pick
					label \Theme
					value? <=> theme? \sky
					dot_color \var(--bog_builderui_control)
					dictionary *
						sky \Sky
						rose \Rose
						violet \Violet
						emerald \Emerald
						amber \Amber
				<= Chart_pick $bog_builderui_studio_pick
					label \Chart Color
					value? <=> chart? \blue
					dot_color \var(--bog_builderui_chart)
					dictionary *
						blue \Blue
						green \Green
						red \Red
						yellow \Yellow
						purple \Purple
			<= Group_fonts $mol_view sub /
				<= Head_pick $bog_builderui_studio_pick
					label \Heading
					value? <=> font_head? \inter
					dictionary *
						inter \Inter
						manrope \Manrope
						dm-sans \DM Sans
						eb-garamond \EB Garamond
				<= Body_pick $bog_builderui_studio_pick
					label \Font
					value? <=> font_body? \inter
					dictionary *
						inter \Inter
						manrope \Manrope
						dm-sans \DM Sans
						eb-garamond \EB Garamond
			<= Group_misc $mol_view sub /
				<= Radius_pick $bog_builderui_studio_pick
					label \Radius
					value? <=> radius? \medium
					dictionary *
						none \None
						small \Small
						medium \Medium
						large \Large
				<= Lights_pick $bog_builderui_studio_pick
					label \Mode
					value? <=> lights? \dark
					dictionary *
						dark \Dark
						light \Light
			<= Spacer $mol_view
			<= Actions_row $mol_view sub /
				<= Shuffle $mol_button_minor
					title \Shuffle
					click? <=> shuffle? null
				<= Share $mol_button_minor
					title \Share
					click? <=> share? null
			<= Get_code $mol_button_major
				title \Get Code
				click? <=> get_code? null
		<= Preview $mol_scroll sub /
			<= Stack $bog_builderui_gallery items /
				<= Buttons_card $bog_builderui_card sub /
					<= Buttons_title $mol_view sub / \Buttons
					<= Btns_row $mol_view sub /
						<= Btn_primary $bog_builderui_button title \Primary
						<= Btn_secondary $bog_builderui_button
							title \Secondary
							variant \secondary
						<= Btn_outline $bog_builderui_button
							title \Outline
							variant \outline
						<= Btn_ghost $bog_builderui_button
							title \Ghost
							variant \ghost
				<= Badges_card $bog_builderui_card sub /
					<= Badges_title $mol_view sub / \Badges
					<= Badges_row $mol_view sub /
						<= Badge_one $bog_builderui_badge title \Active
						<= Badge_two $bog_builderui_badge
							title \Beta
							variant \secondary
						<= Badge_three $bog_builderui_badge
							title \Pro
							variant \outline
						<= Badge_four $bog_builderui_badge
							title \Hot
							variant \destructive
				<= Tabs_card $bog_builderui_card sub /
					<= Tabs_title $mol_view sub / \Tabs
					<= Tabs_demo $bog_builderui_tabs
						value? <=> tabs_value? \overview
						options *
							overview \Overview
							activity \Activity
							settings \Settings
				<= Select_card $bog_builderui_card sub /
					<= Select_title $mol_view sub / \Select
					<= Select_demo $bog_builderui_select
						value? <=> select_value? \medium
						dictionary *
							none \None
							small \Small
							medium \Medium
							large \Large
				<= Card_demo $bog_builderui_card sub /
					<= Card_title $mol_view sub / \Card
					<= Card_text $mol_view sub / \A small description text inside the card.
				<= Alert_demo $bog_builderui_alert
					title \Heads up
					text \You can swap the palette on the left and watch every component repaint.
				<= Toasts_card $bog_builderui_card sub /
					<= Toasts_title $mol_view sub / \Toasts
					<= Toast_info $bog_builderui_toast
						kind \info
						title \Heads up
						text \We've rotated the API tokens. Update your config before Friday.
					<= Toast_success $bog_builderui_toast
						kind \success
						title \Saved
						text \Your theme has been published and is available to teammates.
					<= Toast_warning $bog_builderui_toast
						kind \warning
						title \Trial ends soon
						text \Switch to a paid plan in the next 3 days to keep your workspace.
					<= Toast_error $bog_builderui_toast
						kind \error
						title \Build failed
						text \exit code 1 — see the audit log for the offending TS error.
				<= Avatars_card $bog_builderui_card sub /
					<= Avatars_title $mol_view sub / \Avatars
					<= Avatars_row $mol_view sub /
						<= Avatar_one $bog_builderui_avatar uri \https://i.pravatar.cc/80?img=15
						<= Avatar_two $bog_builderui_avatar uri \https://i.pravatar.cc/80?img=32
						<= Avatar_three $bog_builderui_avatar uri \https://i.pravatar.cc/80?img=47
						<= Avatar_four $mol_avatar id \alice
						<= Avatar_five $mol_avatar id \bob
						<= Avatar_six $mol_avatar id \carol
				<= Sliders_card $bog_builderui_card sub /
					<= Sliders_title $mol_view sub / \Slider
					<= Slider_demo $bog_builderui_slider
						value? <=> slider_value? 40
						min 0
						max 100
				<= Progress_card $bog_builderui_card sub /
					<= Progress_title $mol_view sub / \Progress
					<= Progress_demo $bog_builderui_progress
						value 64
						max 100
				<= Tooltip_card $bog_builderui_card sub /
					<= Tooltip_title $mol_view sub / \Tooltip
					<= Tooltip_demo $bog_builderui_tooltip
						Anchor <= Tooltip_anchor $bog_builderui_button title \Hover me
						bubble_content / \Hello from a tooltip
				<= Skeletons_card $bog_builderui_card sub /
					<= Skeletons_title $mol_view sub / \Skeleton
					<= Skeleton_title_line $bog_builderui_skeleton
					<= Skeleton_line_one $bog_builderui_skeleton
					<= Skeleton_line_two $bog_builderui_skeleton
				<= Dialog_card $bog_builderui_card sub /
					<= Dialog_card_title $mol_view sub / \Dialog
					<= Dialog_open_btn $bog_builderui_button
						title \Open dialog
						click? <=> dialog_open? null
				<= Form_card $bog_builderui_card sub /
					<= Form_title $mol_view sub / \Sign in
					<= Form_subtitle $mol_view sub / \Enter your credentials to access the dashboard
					<= Form_email_block $mol_view sub /
						<= Form_email_label $mol_view sub / \Email
						<= Form_email_input $bog_builderui_field
							hint \you@example.com
						<= Form_email_help $mol_view sub / \We'll never share your email.
					<= Form_password_block $mol_view sub /
						<= Form_password_label $mol_view sub / \Password
						<= Form_password_input $bog_builderui_field
							hint \••••••••
							type \password
					<= Form_actions $mol_view sub /
						<= Form_submit $bog_builderui_button title \Continue
						<= Form_secondary $bog_builderui_button
							title \Cancel
				<= Field_card $bog_builderui_card sub /
					<= Field_title $mol_view sub / \Field
					<= Field_demo $bog_builderui_field
						hint \Type something
				<= Menu_card $bog_builderui_card sub /
					<= Menu_title $mol_view sub / \Menu
					<= Menu_demo $bog_builderui_menu items /
						<= Menu_item_one $bog_builderui_menu_item title \Profile
						<= Menu_item_two $bog_builderui_menu_item title \Settings
						<= Menu_item_three $bog_builderui_menu_item title \Sign out
				<= Breadcrumbs_card $bog_builderui_card sub /
					<= Breadcrumbs_title $mol_view sub / \Breadcrumbs
					<= Breadcrumbs_demo $bog_builderui_breadcrumbs items /
						<= Breadcrumb_home $bog_builderui_breadcrumbs_item
							title \Home
							path \home
						<= Breadcrumb_library $bog_builderui_breadcrumbs_item
							title \Library
							path \home/library
						<= Breadcrumb_data $bog_builderui_breadcrumbs_item
							title \Data
							path \home/library/data
				<= Code_card $bog_builderui_card sub /
					<= Code_title $mol_view sub / \Sources
					<= Code_preview $mol_app_quine
						Head null
						paths /
							\bog/builderui/tokens/tokens.ts
				<= Chart_card $bog_builderui_card sub /
					<= Chart_title $mol_view sub / \Chart
					<= Chart_demo $bog_builderui_chart
						graphs /
							<= Chart_visits $mol_plot_bar
								title \Visits
								series_y <= chart_visits /number
								color <= chart_color_visits \
							<= Chart_signups $mol_plot_bar
								title \Signups
								series_y <= chart_signups /number
								color <= chart_color_signups \
							<= Chart_logins $mol_plot_bar
								title \Logins
								series_y <= chart_logins /number
								color <= chart_color_logins \
							<= Chart_mark_hor $mol_plot_mark_hor
								title \Day
								labels <= chart_labels /string
							<= Chart_ruler_vert $mol_plot_ruler_vert
								title \Count
		<= Dialog_modal $bog_builderui_dialog
			showed? <=> dialog_showed? false
			title \Delete this preset?
			text \This action cannot be undone. Your saved theme will be permanently removed.
			close? <=> dialog_close? null
			confirm? <=> dialog_confirm? null
		<= Get_code_dialog $bog_builderui_dialog
			showed? <=> get_code_showed? false
			title \Get Code
			text \Components will be exported as $<namespace>_<app>_*. Namespace can be empty.
			confirm_title \Download
			close? <=> get_code_close? null
			confirm? <=> get_code_confirm? null
			content /
				<= Namespace_field $bog_builderui_field
					hint \bog (optional)
					value? <=> namespace? \bog
				<= App_name_field $bog_builderui_field
					hint \myapp
					value? <=> app_name? \myapp
